module.exports = __webpack_public_path__ + "static/media/Q_V2.b7fc30d3.svg";